<!-- eslint-disable -->
<template lang="pug">
    .olympiad-container
        .olympiad-container__title(v-if="$route.name === 'olympiads:stage-results'")
            h2.olympiad-container__title-text {{ $i18n.t('olympiads.olympiads_processStage_stageCompleted') }}
        .olympiad-container__title(v-else-if="$route.meta.olympiadTitle === 'olympiad'")
            h2.olympiad-container__title-text {{ $i18n.t('olympiads.olympiads_layout_olympiad') }}
        .olympiad-container__title(v-else-if="$route.meta.olympiadTitle === 'olympiads'")
            h2.olympiad-container__title-text {{ $i18n.t('olympiads.olympiads_layout_olympiads') }}
        router-view
</template>

<script>
    /*eslint-disable*/
    export default {
        mounted () {
            if (window.innerWidth < 578) {
                this.$nextTick(() => {
                    let mainColumn = document.querySelector('.main-column')
                    if (mainColumn
                        && (this.$route.name === 'olympiads:results'
                            || this.$route.name === 'olympiads:show'
                            || this.$route.name === 'olympiads:register')
                    ) {
                        mainColumn.style.backgroundColor = 'transparent';
                        mainColumn.style.paddingTop = 10 + 'px';
                    }
                })
            }
        },
        watch: {
            '$route.name': {
                handler (val) {
                    let mainColumn = document.querySelector('.main-column');
                    if (mainColumn
                        && (val === 'olympiads:results'
                            || val === 'olympiads:show'
                            || val === 'olympiads:register')
                    ) {
                        mainColumn.style.backgroundColor = 'transparent';
                        mainColumn.style.paddingTop = 10 + 'px';
                    } else if (mainColumn) {
                        mainColumn.style.backgroundColor = '';
                        mainColumn.style.paddingTop = '';
                    }
                }
            }
        },
        beforeRouteLeave (to, from, next) {
            let mainColumn = document.querySelector('.main-column')
            if (mainColumn) {
                mainColumn.style.backgroundColor = '';
                mainColumn.style.paddingTop = '';
            }
            next();
        }
    }
</script>

<style lang="scss">
    .olympiad-background {
        background:
            url('../../assets/images/battles/main-background.png'),
            linear-gradient(360deg, #FFFFFF -33.6%, #ADDAAD -4.86%, #6BBD6C 50%);
    }

    .olympiad-container {
        height: 100%;
        padding: 0;
    }

    .olympiad-container__title {
        @include stack-space($space-large);
        @include media($sm) {
            @include stack-space(0);
            @include inset-space($space-large);
        }
        text-align: center;
    }

    .olympiad-container__title-text {
        font-family: Appetite, serif;
        color: $x-color-white;
        font-size: 42px;
        white-space: nowrap;
        @include media($sm) {
            color: $x-color-white;
        }
    }
</style>
